import { MonthYearPeriod } from '@common/neo.tax';
import { Alert, colors, ModalHeader, Typography } from '@ui-components/neo.tax';
import { ReactComponent as Check } from '@ui-components/neo.tax/src/assets/icons/check.svg';

import { periodDisplayName } from '@neo.tax/shared/utils';

export const AllocationModalHeader = ({
  expenseName,
  isForeignExpense,
  period,
  selectedProjectName,
}: {
  expenseName: string;
  isForeignExpense?: boolean;
  period: MonthYearPeriod;
  selectedProjectName?: string;
}): React.ReactElement => (
  <ModalHeader
    icon={<Check color={colors.blue[600]} width={24} />}
    iconBgColor={colors.blue[50]}
    title={
      selectedProjectName ? (
        <Typography as="h3" fontSize="lg">
          <Typography fontSize="lg" fontWeight="medium">
            {expenseName}
          </Typography>{' '}
          on{' '}
          <Typography color={colors.primary[600]} fontSize="lg" fontWeight="medium">
            {selectedProjectName}
          </Typography>
        </Typography>
      ) : (
        <Typography as="h3" fontSize="lg" fontWeight="medium">
          {`Update ${expenseName}'s allocations`}
        </Typography>
      )
    }
    copy={
      <Typography as="p" fontSize="sm">
        {periodDisplayName(period)}
      </Typography>
    }
    alert={
      isForeignExpense ? (
        <Alert
          severity="info"
          title="This expense is ineligible for the R&D credit due to a non-US or unspecified location."
        />
      ) : undefined
    }
  />
);
